// Constants file

// Datatables
export const DT_ROWS_NO = 10;
export const DT_SHORT_ROWS_NO = 5;
export const DT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
export const DT_SHORT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25];
export const DT_PAGINATOR_TEMPLATE = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown';
export const DT_PAGE_REPORT_TEMPLATE = 'Showing {first} to {last} of {totalRecords} entries';
export const DT_REQUESTS_FILTERS = [
    {
        key: 'today',
        name: 'Today',
    },
    {
        key: 'all',
        name: 'All',
    },
    {
        key: 'my-cases',
        name: 'My Cases',
    },
    {
        key: 'sla',
        name: 'SLA',
    },
    {
        key: 'completed',
        name: 'Completed',
    },
    {
        key: 'cho-response-sent',
        name: 'CHO Response',
    },
    {
        key: 'outcome-pending-updates',
        name: 'Outcome Pending Updates',
        highlight: true,
    },
];
export const DT_REPORTS_FILTERS = [
    {
        key: 'today',
        name: 'Today',
    },
    {
        key: 'week',
        name: 'Week',
    },
    {
        key: 'month',
        name: 'Month',
    },
    {
        key: 'all',
        name: 'All',
    },
];
export const DT_REQUESTS_RELOAD_INTERVAL = 60000;

// Max file upload size
export const FILE_UPLOAD_MAX_SIZE = 134217728;

// Flash messages
export const FLASH_MESSAGES_DURATION = 3000;

// Infinite loader
export const IL_ROWS_NO = 15;

// Claim documents
export const CLAIM_DOCUMENTS_ROWS_NO = 100;
export const OCR_DOCUMENTS_ALLOWED_EXTENSIONS = ['.docx', '.doc', '.pdf', '.jpg', '.jpeg', '.png'];
export const CLAIM_DOCUMENTS_ALLOWED_EXTENSIONS = ['image/*', 'application/pdf', 'text/*', 'application/vnd.ms-excel', 'application/msword', '.docx', '.xlsx', '.odt', '.ods', '.csv', '.txt'];

// Claim rulesets
export const CLAIM_RULESETS_ROWS_NO = 100;

export const STATUSES_BOX_SHADOWS = {
    '#BFE2FA': '#8bc8f0',
    '#9BEEFF': '#6ad4e6',
    '#80F9F1': '#5ae6d9',
    '#8DFFCC': '#61cc9f',
    '#BCFF9C': '#87cc6f',
    '#F9F871': '#d5d04c',
    '#8E5090': '#65365b',
    '#5D548A': '#3c3861',
    '#395175': '#27445a',
    '#A3CCB0': '#74a596',
    '#E04662': '#b62f45',
    '#8A4A68': '#623c4a',
    '#94688F': '#66505c',
    '#9B86B2': '#6e6b7a',
};

export const CASE_STATUSES_OPTIONS = [
    {label: 'Received', newColor: '#8bc8f0'},
    {label: 'Assigned', newColor: '#6ad4e6'},
    {label: 'In progress', newColor: '#5ae6d9'},
    {label: 'Running rules', newColor: '#61cc9f'},
    {label: 'Creating response', newColor: '#4bd01d'},
    {label: 'Output created', newColor: '#f1c453'},
    {label: 'OCR requested', newColor: '#ae60e1'},
    {label: 'OCR in progress', newColor: '#744ad5'},
    {label: 'OCR finished', newColor: '#5e56e6'},
    {label: 'OCR failed', newColor: '#b62f45', alternativeTextShadow1: '#000000'},
    {label: 'OCR unsupported', newColor: '#f1c453', alternativeTextShadow1: '#000000'},
    {label: 'Complete', newColor: '#74a596'},
    {label: 'Escalation', newColor: '#623c4a', alternativeTextShadow1: '#000000'},
    {label: 'QA Required', newColor: '#ffb600'},
    {label: 'QA In progress', newColor: '#ff9e00'},
    {label: 'QA Completed', newColor: '#ff7900'},
    {label: 'Refer to DACB', newColor: '#d08c60'},
    {label: 'CHO Response Sent', newColor: '#d9ae94'},
    {label: 'Fraud Check Needed', newColor: '#9b9b7a'},
    {label: 'Fraud Check Completed', newColor: '#797d62'},
    {label: 'Pay Reduced Claim', newColor: '#ed6a5a', alternativeTextShadow1: '#000000'},
    {label: 'Generate Strategy Document', newColor: '#1985a1'},
    {label: 'Outcome Pending Updates', newColor: '#9a8c98'},
];

export const CLAIMANT_OCCUPATION_OPTIONS = [
    {
        label: 'Manual Input...',
        value: 'manual-input',
    },
    {
        label: 'Professional Sportsmen',
        value: 'professional-sportsmen',
    },
    {
        label: 'Professional Sportswoman',
        value: 'professional-sportswoman',
    },
    {
        label: 'Actor',
        value: 'actor',
    },
    {
        label: 'Entertainer',
        value: 'entertainer',
    },
    {
        label: 'Gambler',
        value: 'gambler',
    },
    {
        label: 'Musician',
        value: 'musician',
    },
    {
        label: 'Publican',
        value: 'publican',
    },
    {
        label: 'Journalist',
        value: 'journalist',
    },
    {
        label: 'Convicted with unspent ban',
        value: 'convicted-with-unspent-ban',
    },
];

export const DAMAGE_ROUTE_OPTIONS = [
    {
        label: 'Repair',
        value: 'repair',
    },
    {
        label: 'Total Loss',
        value: 'total-loss',
    },
    {
        label: 'Cash In Lieu',
        value: 'cash-in-lieu',
    },
];

export const CHO_FCA_STATUS_OPTIONS = [
    {
        label: 'Registered',
        value: 'registered',
    },
    {
        label: 'Unregistered',
        value: 'not-registered',
    },
];
export const FIRST_NOTIFICATION_OPTIONS = [
    {
        label: 'Verify',
        value: 'verify',
    },
    {
        label: 'Email',
        value: 'email',
    },
    {
        label: 'Letter',
        value: 'letter',
    },
    {
        label: 'Fax',
        value: 'fax',
    },
];

export const PARTY_DEALING_OPTIONS = [
    {
        label: 'At fault insurer',
        value: 'at-fault-insurer',
    },
    {
        label: 'Claimant insurer',
        value: 'claimant-insurer',
    },
    {
        label: 'CHO',
        value: 'cho',
    },
];

export const VEHICLE_STATUS_OPTIONS = [
    {
        label: 'Roadworthy',
        value: 'roadworthy',
    },
    {
        label: 'Unroadworthy',
        value: 'unroadworthy',
    },
];
export const METHOD_OF_NOTIFICANTION_OPTIONS = [
    {
        label: 'OCR',
        value: 'ocr',
    },
    {
        label: 'Data Upload',
        value: 'data-upload',
    },
    {
        label: 'Manual',
        value: 'manual',
    },
    {
        label: 'API',
        value: 'api',
    },
];

export const TYPE_OF_NOTIFICANTION_OPTIONS = [
    {
        label: 'First Notification',
        value: 'first-notification',
    },
    {
        label: 'Engineers Report',
        value: 'engineers-report',
    },
    {
        label: 'Invoice',
        value: 'invoice',
    },
    {
        label: 'Other Correspondence',
        value: 'other-correspondence',
    },
];

export const ABI_GTA_OPTIONS = [
    {
        label: 'Non-GTA',
        value: 'non-gta',
    },
    {
        label: 'GTA',
        value: 'gta',
    },
];

export const CLAIMANT_VAT_STATUS_OPTIONS = [
    {
        label: 'Registered',
        value: 'registered',
    },
    {
        label: 'Not Registered',
        value: 'not_registered',
    },
];

export const SUPPORTED_OCR_CHOS = [
    'Auxillis',
    'Ax',
    'Easidrive',
    'Enterprise',
    'Kindertons',
    'Onhire',
    '4th Dimension'
]
